import { NavigateOptions, useNavigate } from 'react-router-dom';
import { addRedirectParam } from 'utils/route';

type CustomNavigate = {
    pathname: string;
    search?: string;
};
export const useCustomNavigate = () => {
    const navigate = useNavigate();

    const navigateWithSearch = ({ pathname, search = window.location.search }: CustomNavigate, options?: NavigateOptions) => {
        if (options) {
            navigate({ pathname, search }, options);
            return;
        }
        navigate({ pathname, search });
    };

    const navigateWithRedirectTo = ({ pathname, search = window.location.search }: CustomNavigate, options?: NavigateOptions) => {
        if (options) {
            navigate({ pathname, search: addRedirectParam(search, location.pathname) }, options);
            return;
        }
        navigate({ pathname, search: addRedirectParam(search, location.pathname) });
    };

    const switchMapZone = (currentZone: string, newZone: string, options?: NavigateOptions) => {
        const encodedCurrentZone = encodeURIComponent(currentZone);
        const encodedNewZone = encodeURIComponent(newZone);
        const newPath = location.pathname.replace(encodedCurrentZone, encodedNewZone);
        if (options) {
            navigate(newPath, options);
            return;
        }

        navigate(newPath);
    };

    return {
        navigate,
        navigateWithSearch,
        navigateWithRedirectTo,
        switchMapZone
    };
};
